// Koleksiyon Seviyesi ödülleri: her N seviyede kazanılan ödül
// Ödül tipleri: gem, chest5, evoChest, joker, banner, banner_special, tower

// Joker nadirlik → resim (public/wildcards)
export const WILDCARD_IMG = {
  common: "/wildcards/common.png",
  rare: "/wildcards/rare.png",
  epic: "/wildcards/epic.png",
  legendary: "/wildcards/legendary.png",
  champion: "/wildcards/champion.png",
};

export const WILDCARD_TR = {
  common: "Sıradan Joker",
  rare: "Ender Joker",
  epic: "Destansı Joker",
  legendary: "Efsanevi Joker",
  champion: "Şampiyon Joker",
};

// Banner adı → görsel yolu (public/rewards)
export const BANNER_IMG_MAP = {
  "Bronz Banner": "/rewards/banner-bronze.png",
  "Gümüş Banner": "/rewards/banner-silver.png",
  "Altın Banner": "/rewards/banner-gold.png",
  "Bronz Domuz Binicisi Flaması": "/rewards/banner-hogrider.png",
  "Gümüş Mini Pekka Flaması": "/rewards/banner-minipekka.png",
  "Altın Prens Flaması": "/rewards/banner-prince.png",
};

// Yardımcı fonksiyonlar
const gem = (n) => ({ type: "gem", qty: n, label: `${n} Taş` });
const chest5 = () => ({ type: "chest5", qty: 1, label: "5 Yıldızlı Sandık" });
const evo = () => ({ type: "evoChest", qty: 1, label: "Evrim Sandığı" });
const jk = (rarity, n) => ({ type: "joker", rarity, qty: n, label: `${n} ${WILDCARD_TR[rarity]}` });
const banner = (label) => ({ type: "banner", qty: 1, label });
const tower = (label) => ({ type: "tower", qty: 1, label });

// { level: rewardObj }
export const COLLECTION_REWARDS = {
  20: gem(50),
  30: gem(50),
  40: gem(50),
  50: chest5(),
  60: jk("common", 20),
  70: gem(30),
  80: jk("common", 20),
  90: gem(30),
  100: chest5(),
  110: jk("common", 20),
  120: gem(40),
  130: jk("common", 20),
  140: gem(40),
  150: chest5(),
  160: gem(40),
  170: jk("common", 20),
  180: gem(50),
  190: evo(),
  200: chest5(),
  210: jk("common", 20),
  220: gem(50),
  230: jk("common", 20),
  240: gem(60),
  250: chest5(),
  260: gem(60),
  270: jk("common", 20),
  280: gem(60),
  290: jk("common", 20),
  300: chest5(),
  310: jk("common", 20),
  320: jk("rare", 10),
  330: jk("common", 20),
  340: gem(70),
  350: chest5(),
  360: jk("common", 20),
  370: evo(),
  380: jk("common", 20),
  390: gem(80),
  400: chest5(),
  410: jk("rare", 20),
  420: jk("common", 60),
  430: gem(90),
  440: jk("rare", 20),
  450: evo(),
  460: gem(90),
  470: jk("rare", 20),
  480: jk("common", 60),
  490: gem(90),
  500: chest5(),
  510: jk("common", 60),
  520: jk("epic", 1),
  530: gem(100),
  540: jk("common", 60),
  550: evo(),
  560: jk("common", 60),
  570: gem(100),
  580: jk("rare", 20),
  590: jk("common", 60),
  600: chest5(),
  610: jk("common", 250),
  620: gem(100),
  630: jk("rare", 60),
  640: jk("epic", 6),
  650: chest5(),
  660: gem(125),
  670: jk("common", 250),
  680: jk("rare", 60),
  690: gem(125),
  700: chest5(),
  710: jk("epic", 6),
  720: jk("common", 250),
  730: evo(),
  740: gem(125),
  750: chest5(),
  760: jk("rare", 60),
  770: jk("common", 250),
  780: gem(125),
  790: jk("epic", 6),
  800: chest5(),
  810: jk("rare", 60),
  820: jk("common", 250),
  830: gem(125),
  840: jk("common", 250),
  850: gem(150),
  860: jk("rare", 60),
  870: jk("epic", 6),
  880: gem(150),
  890: jk("common", 250),
  900: chest5(),
  910: evo(),
  920: jk("epic", 6),
  930: gem(150),
  940: jk("rare", 60),
  950: chest5(),
  960: gem(150),
  970: jk("epic", 6),
  980: jk("common", 250),
  990: gem(150),
  1000: banner("Bronz Banner"),
  1010: jk("common", 450),
  1020: jk("legendary", 2),
  1030: gem(150),
  1040: jk("common", 450),
  1050: jk("epic", 15),
  1060: gem(175),
  1070: jk("common", 450),
  1080: evo(),
  1090: jk("common", 450),
  1100: chest5(),
  1110: gem(150),
  1120: jk("rare", 120),
  1130: jk("legendary", 2),
  1140: gem(175),
  1150: chest5(),
  1160: jk("common", 450),
  1170: gem(175),
  1180: jk("rare", 120),
  1190: jk("epic", 15),
  1200: banner("Bronz Domuz Binicisi Flaması"),
  1210: gem(175),
  1220: jk("rare", 120),
  1230: jk("common", 450),
  1240: gem(175),
  1250: jk("legendary", 2),
  1260: evo(),
  1270: jk("epic", 15),
  1280: gem(200),
  1290: jk("rare", 120),
  1300: chest5(),
  1310: jk("common", 450),
  1320: gem(200),
  1330: jk("rare", 120),
  1340: jk("epic", 15),
  1350: chest5(),
  1360: jk("champion", 1),
  1370: jk("common", 450),
  1380: gem(200),
  1390: jk("legendary", 2),
  1400: banner("Gümüş Banner"),
  1410: jk("epic", 30),
  1420: gem(200),
  1430: jk("common", 1000),
  1440: evo(),
  1450: jk("common", 1000),
  1460: gem(200),
  1470: jk("common", 1000),
  1480: jk("epic", 30),
  1490: gem(225),
  1500: chest5(),
  1505: jk("rare", 200),
  1510: jk("common", 1000),
  1515: gem(225),
  1520: jk("legendary", 4),
  1525: jk("epic", 30),
  1530: gem(225),
  1535: jk("rare", 200),
  1540: jk("common", 1000),
  1545: jk("champion", 2),
  1550: chest5(),
  1555: jk("epic", 30),
  1560: gem(225),
  1565: jk("rare", 200),
  1570: jk("common", 1000),
  1575: gem(225),
  1580: jk("legendary", 4),
  1585: jk("epic", 30),
  1590: gem(225),
  1595: jk("champion", 2),
  1600: banner("Gümüş Mini Pekka Flaması"),
  1605: jk("common", 1000),
  1610: gem(225),
  1615: evo(),
  1620: jk("rare", 200),
  1625: jk("epic", 30),
  1630: gem(225),
  1635: jk("rare", 200),
  1640: jk("common", 1000),
  1645: jk("legendary", 4),
  1650: gem(225),
  1655: jk("epic", 30),
  1660: gem(225),
  1665: jk("epic", 30),
  1670: gem(225),
  1675: jk("rare", 200),
  1680: jk("common", 1000),
  1685: jk("epic", 30),
  1690: gem(225),
  1695: jk("rare", 200),
  1700: evo(),
  1705: jk("common", 1000),
  1710: jk("legendary", 4),
  1715: jk("champion", 2),
  1720: jk("rare", 200),
  1725: jk("epic", 30),
  1730: jk("common", 1000),
  1735: gem(250),
  1740: jk("rare", 200),
  1745: jk("common", 1000),
  1750: chest5(),
  1755: gem(250),
  1760: jk("rare", 200),
  1765: jk("champion", 2),
  1770: jk("legendary", 4),
  1775: gem(250),
  1780: jk("rare", 200),
  1785: jk("epic", 30),
  1790: evo(),
  1795: jk("epic", 30),
  1800: banner("Altın Banner"),
  1805: gem(250),
  1810: jk("rare", 300),
  1815: gem(250),
  1820: jk("epic", 40),
  1825: gem(250),
  1830: jk("rare", 300),
  1835: jk("epic", 40),
  1840: jk("legendary", 4),
  1845: gem(250),
  1850: jk("rare", 300),
  1855: gem(250),
  1860: jk("rare", 300),
  1865: jk("epic", 40),
  1870: gem(250),
  1875: jk("champion", 3),
  1880: jk("rare", 300),
  1885: jk("epic", 40),
  1890: jk("rare", 300),
  1895: gem(250),
  1900: chest5(),
  1905: gem(250),
  1910: jk("legendary", 4),
  1915: jk("rare", 300),
  1920: gem(250),
  1925: jk("rare", 300),
  1930: jk("epic", 40),
  1935: gem(250),
  1940: jk("epic", 40),
  1945: jk("rare", 300),
  1950: chest5(),
  1955: gem(250),
  1960: jk("legendary", 4),
  1965: gem(275),
  1970: evo(),
  1975: jk("epic", 40),
  1980: jk("rare", 300),
  1985: jk("champion", 3),
  1990: jk("common", 1750),
  1995: jk("epic", 40),
  2000: banner("Altın Prens Flaması"),
  2005: gem(275),
  2010: jk("epic", 55),
  2015: jk("common", 2250),
  2020: evo(),
  2025: jk("common", 2250),
  2030: jk("legendary", 6),
  2035: gem(275),
  2040: jk("champion", 4),
  2045: jk("common", 2250),
  2050: jk("epic", 55),
  2055: gem(275),
  2060: jk("epic", 55),
  2065: gem(275),
  2070: jk("common", 2250),
  2075: jk("rare", 400),
  2080: gem(275),
  2085: jk("epic", 55),
  2090: jk("legendary", 6),
  2095: gem(275),
  2100: chest5(),
  2105: jk("epic", 55),
  2110: jk("rare", 400),
  2115: gem(275),
  2120: jk("rare", 400),
  2125: jk("epic", 55),
  2130: gem(275),
  2135: jk("epic", 55),
  2140: gem(275),
  2145: evo(),
  2150: tower("Kule Görünümü"),
  2155: gem(275),
  2160: jk("epic", 55),
  2165: gem(275),
  2170: jk("legendary", 6),
  2175: jk("rare", 400),
  2180: jk("epic", 55),
  2185: gem(275),
  2190: jk("epic", 55),
  2195: gem(275),
  2200: chest5(),
  2205: jk("champion", 4),
  2210: jk("rare", 400),
  2215: jk("common", 2250),
  2220: jk("legendary", 6),
  2225: jk("epic", 55),
  2230: gem(300),
  2235: jk("epic", 55),
  2240: jk("rare", 400),
  2245: jk("common", 2250),
  2250: jk("rare", 400),
  2255: jk("epic", 55),
  2260: gem(300),
  2265: jk("common", 2250),
  2270: jk("rare", 400),
  2275: jk("epic", 55),
  2280: jk("legendary", 6),
  2285: jk("epic", 55),
  2290: gem(300),
  2295: jk("common", 2250),
  2300: chest5(),
  2305: jk("rare", 400),
  2310: jk("epic", 55),
  2315: jk("champion", 4),
  2320: evo(),
  2325: jk("epic", 55),
  2330: gem(300),
  2335: jk("common", 2250),
  2340: jk("rare", 400),
  2345: jk("epic", 55),
  2350: jk("legendary", 6),
  2355: jk("epic", 55),
  2360: gem(300),
  2365: jk("common", 2250),
  2370: jk("champion", 4),
  2375: jk("epic", 55),
  2380: jk("rare", 400),
  2385: jk("epic", 55),
  2390: gem(300),
  2395: jk("common", 2250),
  2400: chest5(),
  2405: jk("legendary", 6),
  2410: jk("common", 2250),
  2415: jk("epic", 55),
  2420: jk("common", 2250),
  2425: jk("epic", 55),
  2430: jk("rare", 400),
  2435: jk("common", 2250),
  2440: jk("rare", 400),
  2445: jk("epic", 55),
  2450: gem(300),
  2455: jk("epic", 55),
  2460: jk("rare", 400),
  2465: jk("legendary", 6),
  2470: jk("champion", 4),
  2475: jk("epic", 55),
  2480: gem(300),
  2485: jk("common", 2250),
  2490: jk("rare", 400),
  2495: evo(),
  2500: chest5(),
};

// Ödül seviyeleri artan sırayla
export const REWARD_LEVELS = Object.keys(COLLECTION_REWARDS)
  .map((k) => parseInt(k, 10))
  .sort((a, b) => a - b);

// [current+1, target] arasındaki ödülleri (level bazlı) döndürür
export function getRewardsBetween(current, target) {
  const cur = Number(current) || 0;
  const tgt = Number(target) || 0;
  if (tgt <= cur) return [];
  return REWARD_LEVELS
    .filter((lv) => lv > cur && lv <= tgt)
    .map((lv) => ({ level: lv, ...COLLECTION_REWARDS[lv] }));
}

// Tüm ödüller (info modalı için)
export function getAllRewards() {
  return REWARD_LEVELS.map((lv) => ({ level: lv, ...COLLECTION_REWARDS[lv] }));
}

// Toplu özet: {gems, chest5, evoChest, banners, towers, jokers: {common,rare,epic,legendary,champion}}
export function summarizeRewards(list) {
  const sum = {
    gems: 0,
    chest5: 0,
    evoChest: 0,
    banners: [],
    towers: [],
    jokers: { common: 0, rare: 0, epic: 0, legendary: 0, champion: 0 },
  };
  for (const r of list) {
    if (r.type === "gem") sum.gems += r.qty;
    else if (r.type === "chest5") sum.chest5 += 1;
    else if (r.type === "evoChest") sum.evoChest += 1;
    else if (r.type === "banner") sum.banners.push({ level: r.level, label: r.label });
    else if (r.type === "tower") sum.towers.push({ level: r.level, label: r.label });
    else if (r.type === "joker") sum.jokers[r.rarity] = (sum.jokers[r.rarity] || 0) + r.qty;
  }
  return sum;
}
